<template>
  <textarea
    v-model.trim="text"
    :maxlength="maxlength"
    @focus="$emit('focus')"
    @keyup="handleChange"
    @keydown="pressEnter($event)"
  ></textarea>
</template>

<script>
import autosize from 'autosize'
export default {
  props: {
    value: {
      default: null
    },
    maxlength: {
      default: null
    }
  },
  data: function() {
    return {
      text: this.value
    }
  },
  mounted() {
    autosize(this.$el)
  },
  methods: {
    handleChange(e) {
      this.$emit('input', e.target.value)
    },
    pressEnter(event) {
      // Get the code of pressed key
      const keyCode = event.which || event.keyCode

      // 13 represents the Enter key
      if (keyCode === 13 && !event.shiftKey) {
        // Don't generate a new line
        event.preventDefault()
        this.$emit('pressEnter')

        // Do something else such as send the message to back-end
        // ...
      }
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      var vm = this
      if (newVal != oldVal) {
        vm.text = vm.value
        vm.$nextTick(function() {
          autosize.update(vm.$el)
        })
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/AutoresizeTextarea.vue